import { render, staticRenderFns } from "./video_component.vue?vue&type=template&id=b66b107c&scoped=true&"
import script from "./video_component.vue?vue&type=script&lang=js&"
export * from "./video_component.vue?vue&type=script&lang=js&"
import style0 from "./video_component.vue?vue&type=style&index=0&id=b66b107c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66b107c",
  null
  
)

export default component.exports